import { createSelector } from '@reduxjs/toolkit';
import * as React from 'react';
import { Redirect } from 'react-router-dom';

import { projectsActionCreators } from 'src/actions/projects/actionCreators';
import { ROUTE } from 'src/constants/routes';
import { ProjectNavbar } from 'src/containers/Project/ProjectNavbar';
import { ProjectView } from 'src/containers/Project/ProjectView';
import { projectSelector } from 'src/selectors/project';
import { useHasProject } from 'src/utils/hooks/useHasProject';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

const missingProjectDetailsSelector = (projectId: string) =>
  createSelector(projectSelector(projectId), (project) => {
    return {
      id: projectId,
      name: project?.name,
    };
  });

const useMissingProjectDetails = () => {
  const { projectId } = useRouterParams();
  return useReduxSelector(missingProjectDetailsSelector(projectId));
};

export const Project: React.VFC = () => {
  const hasProject = useHasProject();

  const dispatch = useReduxDispatch();
  const missingProjectDetails = useMissingProjectDetails();
  React.useEffect(() => {
    if (!hasProject) {
      dispatch(
        projectsActionCreators.openedMissingProject(missingProjectDetails)
      );
    }
  }, [hasProject, missingProjectDetails, dispatch]);

  return hasProject ? (
    <>
      <ProjectNavbar />
      <ProjectView />
    </>
  ) : (
    <Redirect to={ROUTE.HOME} />
  );
};
